/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import isNil from 'lodash.isnil';
import {Group, Link} from '@ion/core/src/types/entities';

/**
   * Provides a utility to update the selected Group's parent Account when the
   * user searches and edits a Group from the Global Search to ensure Groups
   * are properly associated with the correct Account.
   */
export const updateGroupParentAccount = (group: Group, parentAccount: Link): Group => (
  !isNil(parentAccount) ? {
    ...group,
    account : parentAccount
  } : group
);
